import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["innerHTML"]

import {
	computed,
	ref,
	watch,
	useAttrs
} from 'vue'

type AppIconProps = {
	name: string,
	size?: string | number,
	width?: string | number,
	height?: string | number,
	color?: string,
	hoverColor?: string,
	cursor?: 'pointer' | string,
	className?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AppIcon',
  props: {
    name: {},
    size: { default: '14px' },
    width: {},
    height: {},
    color: { default: 'currentColor' },
    hoverColor: {},
    cursor: {},
    className: { default: '' }
  },
  setup(__props: any) {

const props = __props

const attrs = useAttrs()
const svgContent = ref('')
const isHovered = ref(false)

const loadSvg = () => {
	try {
		const module = require(`!!raw-loader!@/assets/icons/${props.name}.svg`)
		svgContent.value = module.default || module
	} catch (error) {
		console.warn(`SVG icon "${props.name}" not found:`, error)
		svgContent.value = ''
	}
}

const svgStyle = computed(() => {
	const style = {
		display: 'inline-block',
		verticalAlign: 'middle',
		fill: props.color,
		color: props.color
	}

	if (props.width) {
		style.width = props.width
		style.minWidth = props.width
		style.height = props.height || props.width
	} else if (props.size) {
		style.width = props.size
		style.minWidth = props.size
		style.height = props.size
	}

	if (props.cursor) {
		style.cursor = props.cursor
	}

	if (props.hoverColor) {
		style.color = isHovered.value ? props.hoverColor : props.color
	}

	return style
})

watch(() => props.name,
	loadSvg,
	{ immediate: true }
)

return (_ctx: any,_cache: any) => {
  return (svgContent.value)
    ? (_openBlock(), _createElementBlock("span", _mergeProps({
        key: 0,
        innerHTML: svgContent.value,
        style: svgStyle.value,
        class: ['svg-icon', _ctx.className]
      }, _unref(attrs), {
        onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (isHovered.value = true)),
        onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (isHovered.value = false))
      }), null, 16, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})